import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[EmailValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => EmailValidatorDirective),
    multi: true
  }],
  standalone: false,
})
export class EmailValidatorDirective {

  constructor() { }

    validate(control: AbstractControl): ValidationErrors | null {
      const email = control.value;
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const invalidSequencePattern = /(\.{2,})|(@\.)|(\.@)/;

      if(email?.length < 6){
        return { invalidEmail: true };
      }
      if (!emailPattern.test(email) || invalidSequencePattern.test(email)) {
        return { invalidEmail: true };
      }
      return null;
    }
}
